import React from "react";
import PolicyPage from "./PolicyPage";
import { policies } from "../Datas/policyData";

function Returns() {
  return <PolicyPage policy={policies.returns} />;
}

export default Returns;
